"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const knowledge_repository_1 = require("./knowledge.repository");
let KnowledgeService = class KnowledgeService {
    constructor(repo) {
        this.repo = repo;
    }
    async createFile(file, dto, userId) {
        return await this.repo.createFileEntry(file, {
            ...dto,
            createdBy: userId,
            updatedBy: userId,
        });
    }
    createUrl(dto, userId) {
        return this.repo.createUrlEntry({
            ...dto,
            relativePath: dto.url,
            createdBy: userId,
            updatedBy: userId,
        });
    }
    async replaceFile(documentId, file, userId, data) {
        return await this.repo.replaceFile(documentId, file, userId, data);
    }
    async replaceUrl(documentId, url, userId, data = {}) {
        return await this.repo.replaceUrl(documentId, url, userId, data);
    }
    async updateMetadata(documentId, dto, userId) {
        return await this.repo.updateMetadata(documentId, dto, userId);
    }
    async delete(documentId, userId) {
        return await this.repo.softDelete(documentId, userId);
    }
    list(categoryId, page = 1, limit = 10) {
        return this.repo.list(categoryId, page, limit);
    }
    listForAllCategories(start = 0, limit = 10) {
        return this.repo.listForAllCategories(start, limit);
    }
    async incrementAccess(documentId) {
        return await this.repo.incrementAccessCount(documentId);
    }
    async download(documentId) {
        // Validation for required field
        if (!documentId || isNaN(Number(documentId))) {
            throw new common_1.BadRequestException("documentId is required and must be a valid number.");
        }
        const entry = await this.repo.findActiveDocument(documentId);
        if (!entry) {
            throw new common_1.NotFoundException('Document not found');
        }
        await this.repo.incrementAccessCount(documentId);
        const fileName = entry.fileName;
        // Get the file stream and metadata (works for both S3 and local)
        const fileResult = await this.repo.getFileStream(entry.relativePath);
        // Validate fileResult and stream
        if (!fileResult || !fileResult.stream) {
            throw new common_1.NotFoundException('File not found in storage');
        }
        return {
            stream: fileResult.stream,
            fileName,
            mimeType: fileResult.mimeType || 'application/octet-stream',
            contentLength: fileResult.contentLength,
        };
    }
};
exports.KnowledgeService = KnowledgeService;
exports.KnowledgeService = KnowledgeService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof knowledge_repository_1.KnowledgeRepository !== "undefined" && knowledge_repository_1.KnowledgeRepository) === "function" ? _a : Object])
], KnowledgeService);
